import { NewsItem } from '../../core/models/types';

export interface NewsTitlePart { text: string; kind: 'text' | 'player' | 'club'; }

export function newsProfileTargets(item: NewsItem) {
  const facts = item.facts;
  if (item.type === 'private.transfer-market.player-released.v1' || item.type === 'private.transfer-market.player-signed.v1') {
    const signing = facts?.['signing'];
    const clubId = item.type === 'private.transfer-market.player-released.v1' ? signing?.sellerClubId : signing?.buyerClubId;
    return { playerId: signing?.playerDefinitionId, playerName: facts?.['names']?.[signing?.playerDefinitionId],
      clubId, clubName: facts?.['names']?.[clubId] };
  }
  const sale = item.type === 'GAME_SALE_COMPLETED';
  return { playerId: facts?.playerDefinitionId, playerName: facts?.playerName,
    clubId: sale ? facts?.sellerClubId : facts?.buyerClubId,
    clubName: sale ? facts?.['clubName'] : facts?.buyerClubName };
}

export function newsPlayerTitle(item: NewsItem): NewsTitlePart[] | null {
  if (item.type === 'GAME_SALE_COMPLETED' || item.type === 'private.transfer-market.player-released.v1') {
    const { playerId, playerName, clubName } = newsProfileTargets(item);
    if (!playerId?.trim() || !playerName?.trim() || !clubName?.trim()) return null;
    const prefix = clubName + ' ha aceptado una oferta del extranjero de ';
    const suffix = ' por ' + playerName;
    if (!item.title.startsWith(prefix) || !item.title.endsWith(suffix)
      || item.title.length < prefix.length + suffix.length) return null;
    return [
      { text: clubName, kind: 'club' },
      { text: item.title.slice(clubName.length, -playerName.length), kind: 'text' },
      { text: playerName, kind: 'player' },
    ];
  }
  const { playerId, playerName: name, clubName: club } = newsProfileTargets(item);
  if (!['TRANSFER_COMPLETED', 'private.transfer-market.player-signed.v1'].includes(item.type) || !playerId?.trim() || !name?.trim()) return null;
  const at = item.title.indexOf(name);
  if (at < 0) return null;
  const parts: NewsTitlePart[] = [
    { text: item.title.slice(0, at), kind: 'text' },
    { text: name, kind: 'player' },
  ];
  const rest = item.title.slice(at + name.length);
  const clubAt = club ? rest.indexOf(club) : -1;
  if (club && clubAt >= 0) {
    parts.push({ text: rest.slice(0, clubAt), kind: 'text' }, { text: club, kind: 'club' },
      { text: rest.slice(clubAt + club.length), kind: 'text' });
  } else parts.push({ text: rest, kind: 'text' });
  return parts;
}
